<template>
  <div class="remoteSearch">
    <el-select
      ref="select"
      v-model="projectId"
      filterable
      remote
      placeholder="请输入关键词"
      :remote-method="remoteMethod"
      :loading="loading"
      :clearable="false"
      @change="change"
    >
      <el-option
        v-for="item in projectList"
        :key="item.projectId"
        :label="item.projectName"
        :value="item.projectId"
      />
    </el-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  setProject
} from '@/utils/auth'
import { getLockMsg, exportLockPerson } from '@/api/personnel'
import checkPermission from '@/utils/permission'
import moment from 'moment'
import { nanoid } from 'nanoid'
export default {
  components: { },
  data() {
    return {
      loading: false,
      lockLoading: false,
      projectId: this.$store.state.user.projectItem.projectId
    }
  },
  computed: {
    ...mapState({
      projectList: state => state.user.projectList,
      projectItem: state => state.user.projectItem,
      agreementException: state => state.socket.agreementException
    })
  },
  watch: {
    agreementException(data) {
      data.startDate = moment(data.startDate).format('YYYY-MM-DD')
      data.endDate = moment(data.endDate).format('YYYY-MM-DD')
      data.operateType = data.logTypeList.join('、')
      const h = this.$createElement
      const id = nanoid()
      this[`notifyInstance${id}`] = this.$notify({
        title: '政企协议异常通知',
        type: 'warning',
        message: h('div', { style: 'text-align:right' }, [
          h('div', { style: 'color: #929292;text-align:left;margin-bottom:4px', class: 'ellipsis8' }, `协议名称：${data.agreementName}`),
          h('div', { style: 'color: #929292;text-align:left;margin-bottom:4px', class: 'ellipsis8' }, `操作类型：${data.operateType}`),
          h('div', { style: 'color: #929292;text-align:left;margin-bottom:4px', class: 'ellipsis8' }, `记录日期：${data.startDate} ~ ${data.endDate}`),
          h('div', { style: 'color: #929292;text-align:left;margin-bottom:4px', class: 'ellipsis8' }, `异常记录数量：${data.exceptionLogCount}`),
          h('div', { style: 'color: #929292;text-align:left;margin-bottom:10px', class: 'ellipsis8' }, `请查看日志了解异常详细信息`),
          h('div', {}, [
            h('el-button', { props: { }, attrs: { }, on: {
              click: this.close.bind(this, id)
            }}, '已知悉，稍后处理'),
            h('el-button', { props: { type: 'primary' }, attrs: { }, on: {
              click: this.checkLog.bind(this, data.agreementCode)
            }}, '查看日志')
          ])
        ]),
        duration: 0
      })
    }
  },
  created() {
    if (checkPermission('frontSiteProjectAgreementGetLockMsg')) {
      this.getLockMsg()
    }
  },
  mounted() {

  },
  methods: {
    close(agreementCode) {
      this[`notifyInstance${agreementCode}`].close()
    },
    checkLog(agreementCode) {
      this.$store.commit('user/SET_AGREEMENT_CODE', agreementCode)
      this.$store.commit('user/SET_LOG_DIALOG_VISI', true)
    },
    async remoteMethod(e) {
      this.loading = true
      await this.$store.dispatch('user/siteProjectQueryByCurrentUser', { projectNameKeyWord: e, isRemoteSearch: true })
      this.loading = false
    },
    change(e) {
      if (this.projectItem.projectId !== e) {
        this.$store.commit('user/SET_IS_VISIBLE', false)
        const item = this.projectList.find(item => item.projectId === e)
        this.$store.commit('user/SET_PROJECT_ITEM', item)
        setProject(item.projectId)
        this.$nextTick(() => {
          window.location.reload()
        })
      }
    },
    getLockMsg() {
      getLockMsg({ projectId: this.projectItem.projectId }).then(res => {
        if (res.data && res.data.warn) {
          const h = this.$createElement
          this.notifyInstance = this.$notify({
            title: '劳务人员锁定通知',
            type: 'warning',
            message: h('div', { style: 'text-align:right' }, [
              h('div', { style: 'color: #929292;text-align:left', class: 'ellipsis8' }, res.data.msg),
              h('el-button', { props: { type: 'text' }, attrs: { loading: this.loading }, on: {
                click: this.exportExcel
              }}, '导出表格')
            ]),
            duration: 0
          })
        }
      })
    },
    exportExcel() {
      if (this.lockLoading) {
        return
      }
      this.lockLoading = true
      exportLockPerson({ projectId: this.projectItem.projectId }).then(res => {
        this.$message.success(res.message)
        this.notifyInstance.close()
      }).finally(() => {
        this.lockLoading = false
      })
    }
  }
}
</script>

<style scoped>
.remoteSearch{
  margin-right: 10px;
}
</style>
